const common = {
    /**
     * 高精度加法
     * @param [arg1] 第一位。
     * @param [arg2] 第二位。
     */
    accAdd(arg1, arg2) {
        var r1, r2, m, c;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
            var cm = Math.pow(10, c);
            if (r1 > r2) {
                arg1 = Number(arg1.toString().replace(".", ""));
                arg2 = Number(arg2.toString().replace(".", "")) * cm;
            } else {
                arg1 = Number(arg1.toString().replace(".", "")) * cm;
                arg2 = Number(arg2.toString().replace(".", ""));
            }
        } else {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
    },
    /**
     * 高精度减法
     * @param [arg1] 第一位。
     * @param [arg2] 第二位。
     */
    accSub(arg1, arg2) {
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    /**
     * 匹配身份证
     */
    cardIdReg: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    /**
     * 匹配手机号
     */
    phoneReg: /^1[3|4|5|6|7|8][0-9]{9}$/,
    /**
     * 压缩图片
     * @param [event] change的event。
     */
    upImgCompression(event) {
        // 压缩图片需要的一些元素和对象
        let imgArr = [];
        // 缩放图片需要的canvas
        let canvas = document.createElement('canvas');

        if (navigator.appName == "Microsoft Internet Explorer" && parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE", "")) < 10) {
            return new Promise(function (resolve, reject) {
                alert('您的浏览器版本过低，请下载最新版本');
                return [];
            })
        } else {
            // 选择的文件对象
            // let file = event.target.files;
            let file = event.files;
            let context = canvas.getContext('2d');
            for (let i = 0; i < file.length; i++) {

                var reader = new FileReader(),
                    imgFile = file[i];
                // 选择的文件是图片
                if (imgFile.type.indexOf("image") == 0) {
                    reader.readAsDataURL(imgFile);
                } else {
                    continue;
                }
                let img = new Image();
                // 文件base64化，以便获知图片原始尺寸
                reader.onload = function (e) {
                    img.src = e.target.result;
                };
                var imgP = new Promise(function (resolve, reject) {
                    // base64地址图片加载完毕后
                    img.onload = function () {
                        // 图片原始尺寸
                        var originWidth = this.width;
                        var originHeight = this.height;
                        // 最大尺寸限制
                        var maxWidth = 400,
                            maxHeight = 400;
                        // 目标尺寸
                        var targetWidth = originWidth,
                            targetHeight = originHeight;
                        // 图片尺寸超过400x400的限制
                        if (originWidth > maxWidth || originHeight > maxHeight) {
                            if (originWidth / originHeight > maxWidth / maxHeight) {
                                // 更宽，按照宽度限定尺寸
                                targetWidth = maxWidth;
                                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                            } else {
                                targetHeight = maxHeight;
                                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                            }
                        }
                        // canvas对图片进行缩放
                        canvas.width = targetWidth;
                        canvas.height = targetHeight;

                        // 清除画布
                        context.clearRect(0, 0, targetWidth, targetHeight);
                        // 图片压缩
                        context.drawImage(img, 0, 0, targetWidth, targetHeight);
                        var base64 = canvas.toDataURL("image/png", 0.8);

                        resolve(base64);
                    };
                });
                imgArr.push(imgP);
            }
            // canvas,context = null;
            return Promise.all(imgArr);
        }
    },
    /**
     * 获取url参数
     * @param [name] 需要获取的参数名。
     */
    getQueryString: function (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || '';
    },
    /**
     *根据数据条数与每页多少条数据计算页数 
    * totalnum 数据条数
    * limit 每页多少条
    */
    pageCount(totalnum, limit) {
        return totalnum > 0 ? ((totalnum < limit) ? 1 : ((totalnum % limit) ? (parseInt(totalnum / limit) + 1) : (
            totalnum / limit))) : 0;
    },
    /*  
    获取当前日期

    */
    getDate(type) {
        const date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (type === 'start') {
            year = year - 100;
        } else if (type === 'end') {
            year = year;
        }
        month = month > 9 ? month : '0' + month;
        day = day > 9 ? day : '0' + day;
        return `${year}-${month}-${day}`;

    },

    /*  
    获取前一天日期
    getday(that.objUser.now_time, -90)
    */

    getday(datatime= null, number=0) {
        let nowdate;
        if(datatime) {
            nowdate = new Date(datatime.replace(/-/g,"/"));
        }else {
            nowdate = new Date();
        }
        
        nowdate.setTime(nowdate.getTime() + (24 * 3600 * 1000) * number);
        let y = nowdate.getFullYear();
        let m = nowdate.getMonth() + 1;
        let d = nowdate.getDate();
        
        m = m > 9 ? m : '0' + m;
        d = d > 9 ? d : '0' + d;
        let retrundate = y + '-' + m + '-' + d;
            
        return retrundate;
    }
}

export default common;
